import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { IoTimeSharp } from "react-icons/io5";
import { FaUserAlt } from "react-icons/fa";
import { IoIosTime } from "react-icons/io";
import axios from 'axios';
import './layout.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://backend.ems.uk.hiradentallab.com';

const EditTimingLayout = ({ children }) => {
    const location = useLocation();
    const { userId } = useParams();
    const [user, setUser] = useState(null);

    useEffect(() => {
        const fetchUser = async () => {
            if (!userId) return;
            try {
                // Correct API for User Details
                const response = await axios.get(`${API_BASE_URL}/api/user/user/${userId}`);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user details:', error);
                setUser(null);
            }
        };
        fetchUser();
    }, [userId]);

    return (
        <div className='container-fluid'>
            <h1 className='layouts-subtitle'>
                <IoIosTime /> {user ? `${user.name || user.fullName || 'Employee'} Schedule!` : 'Loading Schedule...'}
            </h1>
            <hr />
            <h1 className='layouts-subtitle'>
                <FaUserAlt /> {user ? `${user.name || user.fullName || 'Employee'}!` : 'Loading...'}
            </h1>
            <hr />

            <div style={{ marginTop: '10px' }}>
                <section>
                    <div className="nav-container">
                        <ul className="nav-list">
                            <li className="nav-item">
                                <NavLink
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                    to={`/edit-timing/${userId}`}
                                >
                                    <IoTimeSharp /> Timing and Shift
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="content">
                        {children}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default EditTimingLayout;